import type { ColorScheme } from '../api/schemes'
import type { ColorTheme } from './Entry/colorTheme'

export function schemeToTheme(s: ColorScheme): ColorTheme {
  return { bg: s.bg, fg: s.fg, color1: s.color1, color2: s.color2 }
}

export function findMatchingScheme(theme: ColorTheme | null, schemes: ColorScheme[]): string | null {
  if (!theme) return null
  const match = schemes.find(
    (s) => s.bg === theme.bg && s.fg === theme.fg && s.color1 === theme.color1 && s.color2 === theme.color2
  )
  return match?.id ?? null
}
